import { ChipWithTooltip } from "ui";
import { Appointment } from "@elixir/types";
import { TooltipComponent } from "ui";
import { PrescriptionSolidIcon } from "@elixir/icons";
import { onPrintPdfInNewTab } from "../../../../utils/bridges/methods";
import { track } from "../../../../utils/tracking";

const PrintRxButton = ({
  apt,
  className = "",
  type = "primary",
}: {
  apt: Appointment;
  className?: string;
  type?: "primary" | "secondary";
}) => {
  return (
    <TooltipComponent
      placement="top"
      title={!!!apt.prescription_id ? "No Prescription Created" : ""}
    >
      <ChipWithTooltip
        title="Print"
        tooltipText={!!!apt.prescription_id ? "No Prescription Created" : ""}
        icon={<PrescriptionSolidIcon className="dr-w-16 dr-min-w-16" />}
        type={type}
        onClick={() => {
          const url = apt.print_prescription_url || apt.prescription_url;
          if (url) {
            window.open(url, "_blank", "default");
          } else {
            track("LANDED_IN_ELSE_DID_NOT_FIND_RX_URL", {
              on: apt.aid,
            });
            onPrintPdfInNewTab(apt.prescription_id || "");
          }
        }}
        isDisabled={!!!apt.prescription_id}
        className={className}
      />
    </TooltipComponent>
  );
};

export default PrintRxButton;
